import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {ExportCustomerPurchasesParams} from "../domain/product-service.types";
import {createProductServiceRepository} from "../data/repositories";

/**
 * Exports a product service's customer purchases as a CSV within a date range.
 * Returns the raw response Blob; the caller inspects `blob.type` to distinguish
 * a `text/csv` download from an `application/json` "nothing to export" message.
 *
 * v2 only — on v1 the repository throws (no export endpoint).
 */
export const useExportCustomerPurchases = () => {
  const repository = createProductServiceRepository();

  return useMutation<Blob, AxiosError<{message: string}>, ExportCustomerPurchasesParams>({
    mutationFn: (params) => repository.exportCustomerPurchases(params),
  });
};
